import "../css/Dashboard.css";
import "../css/Manager.css";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { useState } from "react";
import { useEffect } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from "primereact/column";
import { Link, useNavigate } from "react-router-dom";
import { useRef } from "react";
import { ContextMenu } from 'primereact/contextmenu';
import { Toast } from "primereact/toast";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { apiClient } from "../apiClient";
import colors from '../colors';


function ManageUsers(props)
{
    const cm = useRef(null);
    const toast = useRef(null);
    const [users,setUsers] = useState([]);
    const [updateUsers,setUpdateUsers] = useState(0);
    const [selectedUser, setSelectedUser] = useState({name:"",email:"",phone:"",role:""});
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [showEditUser, setShowEditUser] = useState(false);
    const token = JSON.parse(localStorage.getItem('userToken'));
    const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
    const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
    

 
   
//  bodies******************************************************************************************************************: 
    const regDateBodyTemplate = (rowData) => {
        return new Date(rowData.regDate).toLocaleDateString('fa-IR');
    }
    
    const roleBodyTemplate = (rowData) => {
        if(rowData.role === "subscriber")
            return "مشترک";
        else if(rowData.role === "manager")
            return "مدیر کل";
        else 
            return "-";
        
    }
   
    const mobile_nameBody = (rowData) => { return <span className="mobile-body"><p className="col1">نام:</p> <p className="col2">{rowData.name}</p></span>}
    const mobile_familyNameBody = (rowData) => { return <span className="mobile-body"><p className="col1">نام خانوادگی:</p> <p className="col2">{rowData.familyName}</p></span>}
    const mobile_phone = (rowData) => { return <span className="mobile-body"><p className="col1">شماره تلفن:</p> <p className="col2">{rowData.phone}</p></span>}
    const mobile_emailBody = (rowData) => { return <span className="mobile-body"><p className="col1">ایمیل:</p> <p className="col2">{rowData.email}</p></span>}
    const mobile_planBody = (rowData) => { return <span className="mobile-body"><p className="col1">پلن:</p> <p className="col2">{rowData.plan}</p></span>}
    const mobile_roleBody = (rowData) => { 
      if(rowData.role === "subscriber")
            return <span className="mobile-body"><p className="col1">نقش:</p> <p className="col2">مشترک</p></span>;
        else if(rowData.role === "manager")
            return <span className="mobile-body"><p className="col1">نقش:</p> <p className="col2">مدیر کل</p></span>;
        else 
            return "-";}
  const mobile_regDateBody = (rowData) => { return <span className="mobile-body"><p className="col1">تاریخ عضویت:</p> <p className="col2">{new Date(rowData.regDate).toLocaleDateString('fa-IR')}</p></span>}
      
      
    

/********************************************************************************************************************/ 
    
    const menuModel = [
        {label: 'ویرایش', icon: 'pi pi-fw pi-pencil', command: () => setShowEditUser(true)},
        {label: 'حذف', icon: 'pi pi-fw pi-trash', command: () => setShowConfirmDelete(true)}
    ];


    const deleteUserFromDB = async (_id) => 
    {

      //delete from followings and followers:
      await apiClient.delete(process.env.REACT_APP_BACK+"/notifications/delete-from-follower-and-following/" + _id + "/user", config)
      .catch((error)=>
      {
       
      });
      
      //delete user and her posts and settings:
      await apiClient.delete(process.env.REACT_APP_BACK+"/users/" + _id, config)
      .then(response => 
        {
          if (response.status == 200)
          {
            console.log(response);      
            toast.current.show({severity: 'info', summary: 'کاربر حذف شد'});
            setUpdateUsers(updateUsers+1);    
            
          }

      })
      .catch(error => {
         console.log(error);
       
      });
    }

   

    //get all users from database:
  useEffect(() => {
    async function getAllUsers() {

      
      const result = await apiClient.get(process.env.REACT_APP_BACK+"/users/all",config)
      .then((result) => {
        if (result.status == 200) {
          setUsers(result.data);
          
          
        }
      })
      .catch((error) => {
        console.log(error);
    
      });

      
      

    }
    getAllUsers();
  },[updateUsers]);


   //initialize formik:
   useEffect(() => {
    async function initForm() {

      editUserForm.values.name = selectedUser.name;
      editUserForm.values.email = selectedUser.email;
      editUserForm.values.phone = selectedUser.phone;
      editUserForm.values.plan = selectedUser.plan;
    

      if(selectedUser.role === "manager")
        editUserForm.values.role = "مدیر کل";
      else
        editUserForm.values.role = "مشترک";
      

    }
    initForm();
  },[selectedUser]);

  const editUserForm = useFormik({
    initialValues: {
      name: selectedUser.name,
      email: selectedUser.email,
      phone: selectedUser.phone,
      role: selectedUser.role,
      plan: selectedUser.plan,
      
    },

    onSubmit: (values) => {


      const obj = {};

      for (const key in values) {

        if(key === "role")
        {
          if(values[key] === "مشترک")
            obj[key] = "subscriber";
          else if(values[key]==="مدیر کل")
            obj[key] = "manager";
        }
        else
        {
          obj[key] = values[key];
        }
        
    }


      const data = JSON.stringify(obj);
   
    apiClient.patch(process.env.REACT_APP_BACK+"/users/manage-user/"+selectedUser.username, data, config)
        .then(response => 
          {

          if(response.status == 200)
          {
            console.log(response);
            setShowEditUser(false);
            setUpdateUsers(updateUsers+1);
      
          }

        })
        .catch(error => {
           console.log(error);
        
        });

        
      
    },
  });

    return(
        <div id="manage-users">
            
            <h2>مدیریت کاربران</h2>

            <div className="manager-table">

            <Toast ref={toast}></Toast>

            <ContextMenu model={menuModel} ref={cm} />
            

            {/* for desktop *******************************************************************/}

            { desktop ? 
            <DataTable size="normal" value={users} paginator rows={20} editMode="row"
            contextMenuSelection={selectedUser}
            onContextMenuSelectionChange={e => setSelectedUser(e.value)}
            onContextMenu={e => cm.current.show(e.originalEvent)}>


            
            
            
            <Column alignHeader="center" columnKey="name" align="center" field="name" header="نام "  filter ></Column>
            <Column alignHeader="center" columnKey="familyName" align="center" field="familyName" header="نام خانوادگی"  filter></Column>
            <Column alignHeader="center" columnKey="email" align="center" field="email" header="ایمیل"  filter ></Column>
            <Column alignHeader="center" columnKey="phone" align="center" field="phone" header="شماره تلفن"  filter ></Column>
            <Column alignHeader="center" columnKey="plan" align="center" field="plan" header="پلن فعال"  ></Column>
            <Column alignHeader="center" columnKey="role" align="center" field="role" header="نقش" body={roleBodyTemplate} ></Column>
            <Column alignHeader="center" columnKey="regDate" align="center" field="regDate" header="تاریخ عضویت" body={regDateBodyTemplate} sortable></Column>
            
            
            </DataTable>

            : 
// for mobile******************************************************************************************
            <DataTable size="normal" value={users} paginator rows={20} editMode="row"
            contextMenuSelection={selectedUser}
            onContextMenuSelectionChange={e => setSelectedUser(e.value)}
            onContextMenu={e => cm.current.show(e.originalEvent)}>
            
            <Column alignHeader="center" columnKey="name" align="center" field="name" header="نام " body={mobile_nameBody} filter ></Column>
            <Column alignHeader="center" columnKey="familyName" align="center" field="familyName" header="نام خانوادگی" body={mobile_familyNameBody} filter></Column>
            <Column alignHeader="center" columnKey="email" align="center" field="email" header="ایمیل"  filter body={mobile_emailBody}></Column>
            <Column alignHeader="center" columnKey="phone" align="center" field="phone" header="شماره تلفن"  filter body={mobile_phone}></Column>
            <Column alignHeader="center" columnKey="plan" align="center" field="plan" header="پلن فعال" body={mobile_planBody} ></Column>
            <Column alignHeader="center" columnKey="role" align="center" field="role" header="نقش" body={mobile_roleBody} ></Column>
            <Column alignHeader="center" columnKey="regDate" align="center" field="regDate" header="تاریخ عضویت" body={mobile_regDateBody} sortable></Column>
            
            
            </DataTable>

              }
            </div>


           

            <ConfirmDialog 
            className={props.theme}
            visible={showConfirmDelete} 
            onHide={() => setShowConfirmDelete(false)} 
            message="آیا از حذف این کاربر مطمئنید؟"
            header="تایید حذف"
            icon="pi pi-info-circle"
            acceptLabel="بله"
            rejectLabel="نه"
            acceptClassName="accept"
            rejectClassName="reject"
            accept={() => deleteUserFromDB(selectedUser._id)} 
            reject={() => setShowConfirmDelete(false)} />

            <Dialog
            className={props.theme}
                id="edit-user-dialog"
                header="ویرایش کاربر"
                visible={showEditUser}
                onHide={() => setShowEditUser(false)}
                >
            
          <form onSubmit={editUserForm.handleSubmit} className="p-fluid">
          <div className="field">
                <span>
                  <label htmlFor="name">نام و نام خانوادگی</label>
                  <InputText
                    id="name"
                    name="name"
                    value={editUserForm.values.name}
                    onChange={editUserForm.handleChange}
                  />
                </span>
  
            
            </div>

            <div className="field">
              <label htmlFor="bio">ایمیل</label>
              <span className=" p-input-icon-left">
                <InputText
                  id="email"
                  name="email"
                  value={editUserForm.values.email}
                  onChange={editUserForm.handleChange}
                />
              </span>
            </div>

            <div className="field">
              <label htmlFor="prises">شماره تلفن</label>
              <span className=" p-input-icon-left">
                <InputText
                  id="phone"
                  name="phone"
                  value={editUserForm.values.phone}
                  onChange={editUserForm.handleChange}
                  
                />
              </span>
            </div>

         

         

            <div className="field">
              <label htmlFor="plan">پلن فعال</label>
              <span className=" p-input-icon-left">
              
                 <Dropdown
                    id="plan"
                    name="plan"
                    onChange={editUserForm.handleChange}
                    value={editUserForm.values.plan}
                    options={["موشک","هواپیما","رایگان"]}

                  />
              </span>
            </div>

            <div className="field">
              <label htmlFor="role">نقش</label>
              <span className=" p-input-icon-left">
              <Dropdown
                    id="role"
                    name="role"
                    onChange={editUserForm.handleChange}
                    value={editUserForm.values.role}
                    options={["مشترک","مدیر کل"]}

                  />
              </span>
            </div>

    

          

            <div className="two-columns">
              <div className="field col-one">
                <span>
                  <Button type="submit" label="ذخیره" className="mt-2" />
                </span>
              </div>

              <div className="field col-two">
                <span>
                  <Button
                    className="outline-button mt-2"
                    type="button"
                    label="انصراف"
                    onClick={() => setShowEditUser(false)}
                  />
                </span>
              </div>
            </div>
          </form>
        

        
            </Dialog>

        </div>
    );

}

export default ManageUsers;